exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".notification-panel{position:fixed;top:20px;right:20px;max-width:600px;z-index:3}.notification-panel .notification{color:#fff;width:340px;background-color:#323232;border-radius:4px;margin:0 auto 10px;padding:8px 10px}.notification-panel .notification.notification-error{background-color:#e50000}.notification-panel .notification.notification-primary{background-color:#007ee5}.notification-panel .notification:last-child{margin-bottom:0}.notification-panel .notification-close{float:right;cursor:pointer}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../~/sass-loader!./components/notification/notification.scss
 ** module id = 319
 ** module chunks = 0
 **/